import format from 'date-fns/format'

export const sortDesc = (a, b) => {
  const nameA = a.name.toUpperCase()
  const nameB = b.name.toUpperCase()
  if (nameA < nameB) {
    return -1
  }
  if (nameA > nameB) {
    return 1
  }
  // names must be equal
  return 0
}
export const sortAsc = (a, b) => {
  const nameA = a.name.toUpperCase()
  const nameB = b.name.toUpperCase()
  if (nameA > nameB) {
    return -1
  }
  if (nameA < nameB) {
    return 1
  }
  // names must be equal
  return 0
}

export const sortTimeDesc = (a, b) => {
  return format(a.sortDate, 'x') - format(b.sortDate, 'x')
}
export const sortTimeAsc = (a, b) => {
  return format(b.sortDate, 'x') - format(a.sortDate, 'x')
}



// WEBPACK FOOTER //
// ./src/js/utils.js